// IELTS Mock 2 — Listening (IELTS Fever Listening Practice Test 2)
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through).
// Groups with `optionsBox` show a text box of lettered options instead of an image.
// No `audioStart` timings yet, so the page doesn't auto-scroll between Parts.

const AUDIO_SRC = "/audio/ielts_listening2.mp3";

const IELTS_MOCK2_LISTENING = {
  title: "IELTS Listening Mock 2",
  sections: [
    {
      id: "s1",
      title: "Section 1: Enquiry About Art Class",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 1–3: Choose the correct letter, A, B or C.",
          example: {
            q: "Example: How long has Emma been taking the drama course?",
            options: ["A. from June till now", "B. almost one term", "C. one month"],
            answer: "C. one month",
          },
          image: null,
          questions: [
            {
              id: "q1",
              text: "The teacher praised student Emma for",
              type: "mcq",
              options: [
                "A. her good performance in a public show.",
                "B. setting a good example for others.",
                "C. settling in quickly.",
              ],
              answer: "B",
            },
            {
              id: "q2",
              text: "Why has the timetable for drama class changed?",
              type: "mcq",
              options: [
                "A. Because of falling enrollment.",
                "B. Because the class size is too big.",
                "C. Because of the availability of music room.",
              ],
              answer: "B",
            },
            {
              id: "q3",
              text: "What is the new time for the drama class?",
              type: "mcq",
              options: ["A. 3.15 pm", "B. 4.15 pm", "C. 4.45 pm"],
              answer: "C",
            },
          ],
        },
        {
          instruction:
            "Questions 4–6: What reasons are given for not using these courses? Write the correct letter, A–E, next to Questions 4–6.",
          image: null,
          optionsBox: [
            "A. The course is full.",
            "B. The course fee is too expensive.",
            "C. She has another activity at that time.",
            "D. She has another activity that evening.",
            "E. The class is too late.",
          ],
          mapOptions: ["A", "B", "C", "D", "E"],
          questions: [
            { id: "q4", text: "Dance class", type: "map", answer: "A" },
            { id: "q5", text: "Singing class", type: "map", answer: "D" },
            { id: "q6", text: "Vocal class", type: "map", answer: "B" },
          ],
        },
        {
          instruction:
            "Questions 7–10: Complete the notes below. Write NO MORE THAN TWO WORDS AND/OR A NUMBER for each answer.",
          heading: "Information on Music Class",
          image: null,
          questions: [
            { id: "q7", text: "The class teaches children to play instruments and how to ______", type: "fill_blank", answer: ["write music", "compose music"] },
            { id: "q8", text: "Cost of the course: $______", type: "fill_blank", answer: ["85", "85 dollars"] },
            {
              id: "q9",
              text: "Date Emma starts the course: ______",
              type: "fill_blank",
              answer: ["14 september", "september 14", "14th september", "september 14th", "14 sept", "sept 14"],
            },
            { id: "q10", text: "Teacher: Jamal ______", type: "fill_blank", answer: "curtis" },
          ],
        },
      ],
    },

    {
      id: "s2",
      title: "Section 2: Annual Ski and Snowboard Exhibition",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 11–15: Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q11",
              text: "Why does the speaker recommend the Sky Hotel?",
              type: "mcq",
              options: [
                "A. Because it is quite comfortable.",
                "B. Because it provides ski and snowboard equipment rentals.",
                "C. Because it has health and sports club.",
              ],
              answer: "A",
            },
            {
              id: "q12",
              text: "What is new in this year's exhibition?",
              type: "mcq",
              options: [
                "A. photos of top ski resorts worldwide.",
                "B. ski equipment.",
                "C. computer simulation.",
              ],
              answer: "C",
            },
            {
              id: "q13",
              text: "How do people enter the skiing and snowboarding competition?",
              type: "mcq",
              options: [
                "A. They can send emails to the committee.",
                "B. They can fill out the back of the entrance ticket.",
                "C. They can check out the exhibition newsletter.",
              ],
              answer: "C",
            },
            {
              id: "q14",
              text: "What did the media focus on this year?",
              type: "mcq",
              options: [
                "A. not enough snow.",
                "B. reduction in fee.",
                "C. the decline of participants.",
              ],
              answer: "B",
            },
            {
              id: "q15",
              text: "Why does the speaker recommend the ski program?",
              type: "mcq",
              options: [
                "A. The instructors are quite friendly and patient.",
                "B. It includes lessons and sessions that suit only beginners.",
                "C. It provides special offers at the moment.",
              ],
              answer: "C",
            },
          ],
        },
        {
          instruction:
            "Questions 16–20: What is the focus of each presentation? Choose FIVE answers from the box and write the correct letter, A–F, next to Questions 16–20.",
          image: null,
          optionsBox: [
            "A. exploring new destinations",
            "B. how to make the skiing boots comfortable",
            "C. how to become a ski instructor",
            "D. how to combine other activities with skiing",
            "E. how to improve the skills of skiing",
            "F. information about skiing safety",
          ],
          mapOptions: ["A", "B", "C", "D", "E", "F"],
          questions: [
            { id: "q16", text: "Simon's talk", type: "map", answer: "F" },
            { id: "q17", text: "Solution", type: "map", answer: "B" },
            { id: "q18", text: "Film", type: "map", answer: "A" },
            { id: "q19", text: "Tricks", type: "map", answer: "E" },
            { id: "q20", text: "Johnson's talk", type: "map", answer: "D" },
          ],
        },
      ],
    },

    {
      id: "s3",
      title: "Section 3: Discussion of Pedagogy Course",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 21–23: Complete the sentences below. Write NO MORE THAN TWO WORDS for each answer.",
          image: null,
          questions: [
            { id: "q21", text: "The new teacher who is very popular among students wrote a book titled '______'", type: "fill_blank", answer: "professional learning" },
            { id: "q22", text: "It covers techniques including doing research as part of a ______", type: "fill_blank", answer: ["team", "team research"] },
            { id: "q23", text: "The objective is for the students to present ______ in a collaborative manner.", type: "fill_blank", answer: ["results", "the results"] },
          ],
        },
        {
          instruction:
            "Questions 24–27: Complete the table below. Write NO MORE THAN TWO WORDS for each answer.",
          heading: "Observational method",
          image: null,
          questions: [
            { id: "q24", text: "Observation checklist — Students examine the ______ of peer pupils.", type: "fill_blank", answer: ["behaviour", "behavior"] },
            { id: "q25", text: "Conduct — Keep a ______", type: "fill_blank", answer: "diary" },
            { id: "q26", text: "Observation checklist — Carry out ______", type: "fill_blank", answer: ["video recording", "video recordings"] },
            { id: "q27", text: "Conduct — In-class ______", type: "fill_blank", answer: ["simulation", "simulations"] },
          ],
        },
        {
          instruction:
            "Questions 28–30: Complete the table below. Write NO MORE THAN TWO WORDS for each answer.",
          heading: "Non-observation method",
          image: null,
          questions: [
            { id: "q28", text: "Statistics — Evaluate ______", type: "fill_blank", answer: ["test results", "test result"] },
            { id: "q29", text: "Questionnaires — With the help of ______ to identify respondents", type: "fill_blank", answer: ["internet", "the internet"] },
            { id: "q30", text: "Questionnaires — Choose own respondents to do ______", type: "fill_blank", answer: ["interviews", "interview"] },
          ],
        },
      ],
    },

    {
      id: "s4",
      title: "Section 4: Urban Migration",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 31–40: Complete the notes below. Write ONE WORD ONLY for each answer.",
          heading: "Arguments for and against urban migration",
          image: null,
          questions: [
            { id: "q31", text: "Cities now: consume more ______ than the countryside.", type: "fill_blank", answer: "carbon" },
            { id: "q32", text: "Advantages: good for some ______ to recover.", type: "fill_blank", answer: ["forests", "forest"] },
            { id: "q33", text: "Advantages: poor ______ in the countryside.", type: "fill_blank", answer: ["transport", "transportation"] },
            { id: "q34", text: "Advantages: clean energy — recycling of methane gas produced from ______", type: "fill_blank", answer: ["rubbish", "garbage", "waste"] },
            { id: "q35", text: "For women: better chance of getting a ______ at work.", type: "fill_blank", answer: ["promotion", "promotions"] },
            { id: "q36", text: "Downsides: possible to lose ______ because it is difficult to maintain previous lifestyle.", type: "fill_blank", answer: "culture" },
            { id: "q37", text: "Downsides: higher rates of ______ in the city than in the country.", type: "fill_blank", answer: ["crime", "crimes"] },
            { id: "q38", text: "Downsides: poor quality of ______ in the city.", type: "fill_blank", answer: "air" },
            { id: "q39", text: "Economic factors: Increased ______ in population results in increase in energy consumption.", type: "fill_blank", answer: "welfare" },
            { id: "q40", text: "Economic factors: people find the heavy ______ stressful.", type: "fill_blank", answer: "traffic" },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK2_LISTENING;
